import React from 'react'
import RegularRealtimeDashboard from '@rd-web-markets/market/dist/dashboards/RegularRealtimeDashboard';
import SidebarPortal from '@rd-web-markets/shared/dist/util/SidebarPortal';
import { useParams } from 'react-router-dom';
import claimGroupService from '@rd-web-markets/shared/dist/services/claim_group.service';
import { USE_V2_DESIGN } from '@rd-web-markets/market/dist/constants';
import { Loading } from '@rd-web-markets/shared/dist/util';
import ClaimGroupSidebarV2 from '@rd-web-markets/shared/dist/pages/setup/ClaimGroupSidebarV2';
import { useSetCompanyBreadcrumb } from '@rd-web-markets/shared/dist/util/hooks/useSetCompanyBreadcrumb';

const RegularRealtimeDashboardPage = ({accountType}) => {
  const { claimGroupId } = useParams();
  const [claimGroup] = claimGroupService.useGetClaimGroup(claimGroupId);
  const company = claimGroup?.company;

  useSetCompanyBreadcrumb(company, accountType);

  if (USE_V2_DESIGN && !claimGroup) return <Loading />;

  return (
    <>
      {USE_V2_DESIGN ? (
        claimGroup && (
          <ClaimGroupSidebarV2
            claimGroup={claimGroup}
            company={company}
            claims={claimGroup.claims}
            accountType={accountType}
            highlightedMenuItem='dashboard'
          />
        )
      ) : (
        <SidebarPortal headerItem={{link: 'dashboards', text: 'Dashboards'}} />
      )}
      <div className='mt-3'></div>
      <RegularRealtimeDashboard claimGroup={claimGroup} />
      <div className='mb-5'></div>
    </>
  );
};
export default RegularRealtimeDashboardPage;
